export type ClientRouteFamily =
  | "home"
  | "training"
  | "workout"
  | "exercise_detail"
  | "measurements"
  | "nutrition"
  | "gallery"
  | "settings"
  | "chat"
  | "unknown";

function stripQueryAndHash(input: string): string {
  const queryIndex = input.indexOf("?");
  const hashIndex = input.indexOf("#");
  const splitIndex =
    queryIndex === -1 ? hashIndex : hashIndex === -1 ? queryIndex : Math.min(queryIndex, hashIndex);
  return splitIndex === -1 ? input : input.slice(0, splitIndex);
}

function normalizeTrailingSlash(input: string): string {
  if (input === "/") return input;
  return input.replace(/\/+$/, "") || "/";
}

export function normalizeClientNavigationPath(input: string): string {
  if (!input) return "/";

  if (input.startsWith("/")) {
    return normalizeTrailingSlash(stripQueryAndHash(input));
  }

  try {
    const url = new URL(input, "http://localhost");
    return normalizeTrailingSlash(url.pathname || "/");
  } catch {
    return normalizeTrailingSlash(stripQueryAndHash(input));
  }
}

export function normalizeClientNavigationHref(input: string): string {
  if (!input) return "/";

  try {
    const url = new URL(input, "http://localhost");
    return `${normalizeTrailingSlash(url.pathname || "/")}${url.search}`;
  } catch {
    const hashIndex = input.indexOf("#");
    const withoutHash = hashIndex === -1 ? input : input.slice(0, hashIndex);
    const queryIndex = withoutHash.indexOf("?");
    const path = queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex);
    const search = queryIndex === -1 ? "" : withoutHash.slice(queryIndex);
    return `${normalizeTrailingSlash(path || "/")}${search}`;
  }
}

export function getClientRouteFamily(input: string): ClientRouteFamily {
  const path = normalizeClientNavigationPath(input);

  if (path === "/client") return "home";
  if (path.startsWith("/client/workout")) return "workout";
  if (path.startsWith("/client/exercises/")) return "exercise_detail";
  if (path.startsWith("/client/program")) return "training";
  if (path.startsWith("/client/history")) return "training";
  if (path.startsWith("/client/analysis")) return "training";
  if (path === "/client/exercises") return "training";
  if (path.startsWith("/client/weight")) return "measurements";
  if (path.startsWith("/client/measurements")) return "measurements";
  if (path.startsWith("/client/goals")) return "measurements";
  if (path.startsWith("/client/nutrition")) return "nutrition";
  if (path.startsWith("/client/gallery")) return "gallery";
  if (path.startsWith("/client/settings")) return "settings";
  if (path.startsWith("/client/chat")) return "chat";

  return "unknown";
}
